var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21484 1.56787L5.73516 1.04756C5.95547 0.827246 6.31172 0.827246 6.52969 1.04756L11.0859 5.60147C11.3063 5.82178 11.3063 6.17803 11.0859 6.396L6.52969 10.9522C6.30938 11.1726 5.95313 11.1726 5.73516 10.9522L5.21484 10.4319C4.99219 10.2093 4.99688 9.846 5.22422 9.62803L8.04844 6.9374H1.3125C1.00078 6.9374 0.75 6.68662 0.75 6.3749V5.6249C0.75 5.31318 1.00078 5.0624 1.3125 5.0624H8.04844L5.22422 2.37178C4.99453 2.15381 4.98984 1.79053 5.21484 1.56787Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSmall);
export default __webpack_public_path__ + "static/media/right-small.5701bf00162942b16212e50ec5c636ad.svg";
export { ForwardRef as ReactComponent };